var _path, _rect, _path2, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 100,
    viewBox: "0 0 135 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4028 83.604L8.67916 98.6534C6.16121 99.3099 3.50552 98.2831 2.08407 96.1036C0.81067 94.151 0.772073 91.6406 1.98484 89.6498L34.0342 37.0406C40.1767 26.9576 54.7504 26.7726 61.1468 36.6965L75.8148 59.4534C81.7158 68.6087 76.9428 80.8561 66.4028 83.604Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.0322,
    y: 47.9987,
    width: 24.402,
    height: 38.1043,
    rx: 12.201,
    transform: "rotate(-31.699 33.0322 47.9987)",
    fill: "#334588"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1937_612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 37,
    width: 73,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2467 86.7733L8.67916 98.6534C6.16121 99.3099 3.50552 98.2831 2.08407 96.1036C0.81067 94.151 0.772073 91.6406 1.98484 89.6498L26.4842 49.4339C36.1183 33.6194 58.9765 33.3293 69.0089 48.8943C78.2644 63.2539 70.7781 82.4633 54.2467 86.7733Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1937_612)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 72.4111,
    width: 11.3963,
    height: 38.1043,
    transform: "rotate(-31.699 0 72.4111)",
    fill: "#88F4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2588,
    y: 52.6729,
    width: 11.3963,
    height: 50.9328,
    transform: "rotate(-31.699 14.2588 52.6729)",
    fill: "#88F4FF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15.0775,
    height: 15.0775,
    transform: "matrix(-0.978532 -0.206096 -0.206096 0.978532 122.538 7.58783)",
    fill: "#334588"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.6325,
    height: 10.6325,
    transform: "matrix(-0.996832 0.0795316 0.0795316 0.996832 98.3096 52.5088)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 15.0775,
    height: 6.70111,
    transform: "matrix(-0.964857 0.262777 0.262777 0.964857 80.3218 11.9602)",
    fill: "#88F4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6.21284,
    height: 4.5609,
    transform: "matrix(-0.902092 0.431544 0.431544 0.902092 78.1509 39.3119)",
    fill: "#334588"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6.21284,
    height: 4.5609,
    transform: "matrix(-0.924989 -0.379994 -0.379994 0.924989 131.53 49.2709)",
    fill: "#88F4FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 6.21284,
    height: 4.5609,
    transform: "matrix(-0.178952 -0.983858 -0.983858 0.178952 108.709 37.9779)",
    fill: "#453CBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyIcon);
export default __webpack_public_path__ + "static/media/happy-icon.816290aeb167813d1b56978922c0c152.svg";
export { ForwardRef as ReactComponent };